var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02943 0.5H1.3C0.858171 0.5 0.5 0.858172 0.5 1.3V14.2C0.5 14.6418 0.858172 15 1.3 15H16.7C17.1418 15 17.5 14.6418 17.5 14.2V4.01875C17.5 3.57692 17.1418 3.21875 16.7 3.21875H5.8189C5.56272 3.21875 5.32204 3.09606 5.17153 2.88876L3.6768 0.82999C3.5263 0.622686 3.28561 0.5 3.02943 0.5ZM11.7998 10.05C12.1864 10.05 12.4998 9.7366 12.4998 9.35C12.4998 8.9634 12.1864 8.65 11.7998 8.65H9.6498V6.5C9.6498 6.1134 9.3364 5.8 8.9498 5.8C8.5632 5.8 8.2498 6.1134 8.2498 6.5V8.65H6.0998C5.71321 8.65 5.3998 8.9634 5.3998 9.35C5.3998 9.7366 5.71321 10.05 6.0998 10.05H8.2498V12.2C8.2498 12.5866 8.5632 12.9 8.9498 12.9C9.3364 12.9 9.6498 12.5866 9.6498 12.2V10.05H11.7998Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c1192218c2b4f9cb07feae266aba70ee.svg";
export { ForwardRef as ReactComponent };